import ReportComparativaPreview from "./ReportComparativaPreview";
export default ReportComparativaPreview;